import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, unref as _unref, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "card mb-5 mb-xl-10" }
const _hoisted_2 = {
  class: "card-header border-0 cursor-pointer",
  role: "button",
  "data-bs-toggle": "collapse",
  "data-bs-target": "#kt_account_profile_details",
  "aria-expanded": "true",
  "aria-controls": "kt_account_profile_details"
}
const _hoisted_3 = { class: "card-title w-100 m-0" }
const _hoisted_4 = { class: "d-flex w-100 align-items-center" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "ms-0" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder m-0" }, "Multiple Input Berita")
], -1)
const _hoisted_6 = { class: "ms-auto" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("button", {
  class: "btn btn-secondary me-4",
  type: "button"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa fa-arrow-left" }),
  /*#__PURE__*/_createTextVNode(" Kembali ")
], -1)
const _hoisted_8 = { class: "card-body border-top p-9" }
const _hoisted_9 = {
  key: 0,
  class: "alert alert-success d-flex align-items-center"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle me-1" }, null, -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("strong", null, "Berhasil!", -1)
const _hoisted_12 = { class: "ms-2" }
const _hoisted_13 = {
  key: 1,
  class: "alert alert-info d-flex align-items-center"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle me-1" }, null, -1)
const _hoisted_15 = /*#__PURE__*/_createElementVNode("strong", null, "Perhatian!", -1)
const _hoisted_16 = { class: "ms-2" }
const _hoisted_17 = {
  key: 2,
  class: "alert alert-success d-flex align-items-center"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-info-circle me-1" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("strong", null, "Perhatian!", -1)
const _hoisted_20 = { class: "ms-2" }
const _hoisted_21 = { class: "row" }
const _hoisted_22 = { class: "col-12" }
const _hoisted_23 = { class: "d-flex align-items-center gap-2" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "custom-divider-up mb-4" }, null, -1)
const _hoisted_25 = { class: "col-md-12 mb-4" }
const _hoisted_26 = { class: "d-flex justify-content-end" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("i", { class: "bi bi-x-circle ml-2 fs-4" }, null, -1)
const _hoisted_28 = /*#__PURE__*/_createTextVNode(" Batalkan ")
const _hoisted_29 = [
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = ["data-bs-toggle", "title"]
const _hoisted_31 = ["disabled"]
const _hoisted_32 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-check-circle ml-2 fs-4" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createTextVNode(" Simpan Data ")
const _hoisted_34 = [
  _hoisted_32,
  _hoisted_33
]
const _hoisted_35 = { class: "d-flex justify-content-end mt-2" }
const _hoisted_36 = {
  key: 0,
  class: "text-danger"
}

import { reactive, ref, watchEffect, computed, shallowRef, onMounted } from "vue";
import { setCurrentPageBreadcrumbs } from "@/core/helpers/breadcrumb";
import ApiService from "@/core/services/ApiService";
import { useRouter } from "vue-router";
import type { FormInstance } from "element-plus";
import Swal from "sweetalert2/dist/sweetalert2.js";
import { formatDateTime } from "@/global-helper/handler";

// Variables

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const router = useRouter();
const rule_form_ref = ref<FormInstance>();
const is_show_alert = ref({
  success: false,
  info: false,
  error: false,
});
const data_response_post = ref({
  inserted_count: 0,
  exist_count: 0,
  failed_count: 0,
});

const source = ref("news");
const form = ref<any>();

(window as any).formX = form;

const is_disable_save = computed(() => {
  return false;
});

const sources = ref([
  { value: "news", label: "Media Online", icon: "fas fa-pager" },
  { value: "media_cetak", label: "Media Cetak", icon: "far fa-newspaper" },
  { value: "media_tv", label: "Media TV", icon: "fas fa-tv" },
  { value: "radio", label: "Radio", icon: "bi bi-broadcast-pin" },
  { value: "running_text", label: "Running Text", icon: "bi bi-card-text" },
]);

const component_form = shallowRef<any>(null);

const cancelAction = () => {
  router.push({ name: "berita" });
};

const save_form = (formEl: FormInstance | undefined) => {
  if (!formEl) {
    Swal.fire({
      position: "top-end",
      icon: "error",
      toast: true,
      title: "Inputan Anda belum lengkap. Silahkan Cek kembali!!",
      showConfirmButton: false,
      timer: 3000,
    });
  } else {
    formEl.validate((valid) => {
      if (valid) {
        saveData(formEl);
      } else {
        Swal.fire({
          position: "top-end",
          icon: "error",
          toast: true,
          title: "Inputan Anda belum lengkap. Silahkan Cek kembali!!",
          showConfirmButton: false,
          timer: 3000,
        });
        return false;
      }
    });
  }
};

const saveData = async (formEl: FormInstance | undefined) => {
  const dataPayload = (form.value || []).map((item: Record<string, unknown>) => ({
    ...item,
    date: formatDateTime(item.date),
  }));

  ApiService.sendPayload('post', '/streams/onlinenews/bulk-add', {
    data: dataPayload,
  })
  .then((response) => {
    data_response_post.value = response.data;

    is_show_alert.value.success = true;
    is_show_alert.value.info = true;
    is_show_alert.value.error = true;
    setTimeout(() => {
      is_show_alert.value.success = false;
      is_show_alert.value.info = false;
      is_show_alert.value.error = false;
    }, 30000);

    formEl.resetFields();
    source.value = "news";
    form.value = [];

    Swal.fire({
      title: "Berita Berhasil Ditambahkan!",
      icon: "success",
      confirmButtonText: "Ok",
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-light-primary",
      },
    });
  })
  .catch((error) => {
    Swal.fire({
      title: "Gagal!",
      text: `${error.response.data.message
        ? error.response.data.message
        : error.response.data.detail.message
          ? error.response.data.detail.message
          : "Terjadi kesalahan saat menyimpan berita"
        }`,
      icon: "error",
      confirmButtonText: "Ok",
      buttonsStyling: false,
      customClass: {
        confirmButton: "btn btn-light-primary",
      },
    });
  });
};


// Function

// Life Hook
watchEffect(async () => {
  if (source.value) {
    try {
      const component = (
        await import(`../berita/medkon/form_${source.value}_bulk.vue`)
      ).default;
      component_form.value = component;
      form.value = [];
    } catch (error) {
      component_form.value = null;
    }
  } else {
    component_form.value = null;
  }
});

onMounted(() => {
  setCurrentPageBreadcrumbs("Input Berita", ["Berita"]);
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              to: "/berita/add",
              class: "ms-3"
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            })
          ])
        ])
      ])
    ]),
    _createVNode(_component_el_form, {
      model: form.value,
      ref: (_value, _refs) => {
        _refs['rule_form_ref'] = _value
        rule_form_ref.value = _value
      },
      "label-position": "top"
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          (is_show_alert.value?.success && (data_response_post.value?.inserted_count ?? 0) > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _hoisted_10,
                _hoisted_11,
                _createElementVNode("span", _hoisted_12, _toDisplayString(data_response_post.value.inserted_count || 0) + " Berita berhasil ditambahkan", 1),
                _createElementVNode("i", {
                  class: "bi bi-x ms-auto text-danger",
                  style: {"font-size":"20px","cursor":"pointer"},
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (is_show_alert.value.success = false))
                })
              ]))
            : _createCommentVNode("", true),
          (is_show_alert.value?.info && (data_response_post.value?.exist_count ?? 0) > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _hoisted_14,
                _hoisted_15,
                _createElementVNode("span", _hoisted_16, _toDisplayString(data_response_post.value?.exist_count || 0) + " Link berita sudah terdaftar dalam sistem", 1),
                _createElementVNode("i", {
                  class: "bi bi-x ms-auto text-danger",
                  style: {"font-size":"20px","cursor":"pointer"},
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (is_show_alert.value.info = false))
                })
              ]))
            : _createCommentVNode("", true),
          (is_show_alert.value?.error && (data_response_post.value?.failed_count ?? 0) > 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                _hoisted_18,
                _hoisted_19,
                _createElementVNode("span", _hoisted_20, _toDisplayString(data_response_post.value?.failed_count || 0) + " Berita tidak berhasil ditambahkan", 1),
                _createElementVNode("i", {
                  class: "bi bi-x ms-auto text-danger",
                  style: {"font-size":"20px","cursor":"pointer"},
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (is_show_alert.value.error = false))
                })
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createVNode(_component_el_form_item, {
                label: "* Sumber Berita",
                prop: "source",
                rules: {
                required: false,
                message: 'Sumber Berita Wajib Diisi',
                trigger: ['blur', 'change'],
              }
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_select, {
                    class: "form-control-custom",
                    modelValue: source.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((source).value = $event)),
                    filterable: "",
                    disabled: ""
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sources.value, (source) => {
                        return (_openBlock(), _createBlock(_component_el_option, {
                          key: source.value,
                          label: source.label,
                          value: source.value
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("span", _hoisted_23, [
                              _createElementVNode("i", {
                                class: _normalizeClass(source.icon)
                              }, null, 2),
                              _createTextVNode(" " + _toDisplayString(source.label), 1)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["label", "value"]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["modelValue"])
                ]),
                _: 1
              })
            ]),
            (_unref(component_form))
              ? (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(component_form)), {
                  key: 0,
                  source: source.value,
                  form: form.value,
                  "onUpdate:form": _cache[4] || (_cache[4] = ($event: any) => ((form).value = $event)),
                  type: "add"
                }, null, 8, ["source", "form"]))
              : _createCommentVNode("", true)
          ]),
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, [
            _createElementVNode("div", _hoisted_26, [
              _createElementVNode("button", {
                type: "button",
                class: "btn btn-secondary me-4",
                onClick: cancelAction
              }, _hoisted_29),
              _createElementVNode("span", {
                "data-bs-toggle": _unref(is_disable_save) ? 'tooltip' : '',
                title: _unref(is_disable_save) ? 'Mohon Isikan AD Value' : ''
              }, [
                _createElementVNode("button", {
                  type: "button",
                  onClick: _cache[5] || (_cache[5] = ($event: any) => (save_form(rule_form_ref.value))),
                  class: "btn btn-success",
                  disabled: _unref(is_disable_save)
                }, _hoisted_34, 8, _hoisted_31)
              ], 8, _hoisted_30)
            ]),
            _createElementVNode("div", _hoisted_35, [
              (_unref(is_disable_save))
                ? (_openBlock(), _createElementBlock("div", _hoisted_36, " ** Mohon inputkan " + _toDisplayString(form.value.source == "media_cetak" ? 'salah satu' : '') + " AD Value, nilai tidak boleh 0 ", 1))
                : _createCommentVNode("", true)
            ])
          ])
        ])
      ]),
      _: 1
    }, 8, ["model"])
  ]))
}
}

})